module.exports = __webpack_public_path__ + "static/media/train_4.18a3abcb.png";